import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  ViewChild,
  Output,
  ElementRef,
} from '@angular/core';
import {
  AlertController,
  IonContent,
  IonList,
  ModalController,
  PopoverController,
} from '@ionic/angular';
import { DataService } from '../../services/data.service';
import { Storage } from '@ionic/storage-angular';
// import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-customerss',
  templateUrl: './customerss.component.html',
  styleUrls: ['./customerss.component.scss'],
})
export class CustomerssComponent implements OnInit {

  @Input() customers_list: any = [];
  @Input() all_cutsomer_list: any = [];
  @Input() loadMoreData;
  @Output() search_customers:any = new EventEmitter();
  @Output() customer_data:any = new EventEmitter();
  @Output() new_customer:any = new EventEmitter();
  // @Output() Scrolllist = new EventEmitter();

  // @ViewChild(IonContent) content: IonContent;
  // @ViewChild('category_content') category_content: ElementRef;
  check_box = false;
  pos_page = 0;
  constructor(public storage: Storage,public db:DataService) { }

  ngOnInit() {
    // console.log("DOT",this.customers_list)
    this.db.searchCustomer = null;
  }

  order_list(item){
    this.db.orders_list = false;
    this.passorderdata(item);
    // this.Scrolllist(item.name);
  }

  passorderdata(item){
    // console.log('Cus ID',item.name);
    this.customer_data.emit(item);
  }

  onScroll(event: any) {
    if(this.loadMoreData && !this.db.searchCustomer){
     if(event.target.scrollTop <= 100){
        this.db.scroll_top = true;
     }else{
        this.db.scroll_top = false;
     }
    //  if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
    //    this.db.page_no = this.db.page_no + 15;
    //    this.get_customerslist.emit('');
    //  }
    }
    if(!this.db.searchCustomer){    
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
       // console.log(event);
       this.pos_page = this.pos_page + 15;
       this.get_scroll_data(this.pos_page);
     //    this.db.page_no = this.db.page_no + 15;
   //    // this.db.pending_orders(this.db.typeOfData,'order');
    }
   }  
   }

  //  onScroll(event: any) {
   
  //  if(!this.DBservice.searchCustomer){    
  //   if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
  //      // console.log(event);
  //      this.pos_page = this.pos_page + 15;
  //      this.get_scroll_data(this.pos_page);
  //    //    this.db.page_no = this.db.page_no + 15;
  //  //    // this.db.pending_orders(this.db.typeOfData,'order');
  //   }
  //  } 
  // }

  get_scroll_data(page_no){
    this.storage.get('customer_list').then((val) => {
      if (!val || val.length == 0){

      }
      else {
          var array = val.slice(page_no,page_no+15);
          // console.log(array)
          array.map(res =>{
            this.customers_list.push(res);
          })
          this.all_cutsomer_list = this.customers_list;
      }
    });
  }


  //  Scrolllist(item) {
  //   this.change_category(item)
  // }

  // change_category(category_name) {
  //   console.log(category_name);
  //   // this.active_category = category_name;
  //   var itemList = document.getElementById(category_name);
  //   console.log(itemList);
  //   this.content.scrollToPoint(0, itemList.offsetTop - (this.db.ismobile ? 50 : 10), 500);
  // }


}
